import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import moment from 'moment';
import './MonthPhotoGroup.css';

const MonthPhotoGroup = ({
  month,
  year,
  photos,
  selectPhoto,
  ...props
}) => {
  const monthYearDate = moment().month(month).year(year);
  const monthYearString = monthYearDate.format('MMMM YYYY');

  return (
    <div style={{ margin: '8px 0' }}>
      <Typography type='header'>{monthYearString}</Typography>
      { photos.length > 0
        ? <div className='month-photo-group'>
          { photos.map(photo =>
            <img
              key={`month-${month}-${year}-photo-${photo.key}`}
              src={photo.url}
              alt=''
              onClick={() => selectPhoto(photo)}
            />
          )}
        </div>
        : <Typography>No photos</Typography>
      }
    </div>
  );
};

MonthPhotoGroup.propTypes = {
  month: PropTypes.oneOfType(PropTypes.number, PropTypes.string),
  year: PropTypes.oneOfType(PropTypes.number, PropTypes.string),
  photos: PropTypes.array,
  selectPhoto: PropTypes.func
};

export default React.memo(MonthPhotoGroup);
